module.exports = __webpack_public_path__ + "img/eden-link.da713ba1.svg";